import { BoardingReduxState } from 'state'

export type ConfigOptions = {
  apiUrl: string
  appProtocol: string
  appDomain: string
  superDomain: string
  appPath: string
  bugsnagApiKey: string
  appVersion: string
  googleClientId: string
  environment: string
}

// eslint-disable-next-line no-console
console.log(process.env.NODE_ENV)

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    CONFIG: ConfigOptions
  }
}

const Config = window.CONFIG ?? {}

function getAppPath(): string {
  const appPathFromConfig = Config.appPath
  const appPathFromURL = new URL(window.location.toString()).searchParams.get(
    'appPath'
  )
  return appPathFromURL?.startsWith('/') ? appPathFromURL : appPathFromConfig
}

function getSuperPath(): string {
  const appPathFromConfig = '/super'
  const appPathFromURL = new URL(window.location.toString()).searchParams.get(
    'appPath'
  )
  return appPathFromURL?.startsWith('/') ? appPathFromURL : appPathFromConfig
}

const apiPath = new URL(Config.apiUrl).pathname
export const apiUrl = new URL(apiPath, window.location.origin).toString()
export const appProtocol = Config.appProtocol
export const appDomain = Config.appDomain
export const superDomain = Config.superDomain
export const appPath = getAppPath()
export const superPath = getSuperPath()

export function generateConfig(): ConfigOptions {
  return {
    ...Config,
    apiUrl,
    appPath,
    environment: Config.environment,
  }
}

export function getConfig(state: BoardingReduxState) {
  return state.config
}

export function getAppDomain() {
  return appDomain
}

export function getWebsiteUrl() {
  return `${appProtocol}${appDomain}`
}

export default function reducer(state = generateConfig()) {
  return state
}
